export default "__VITE_ASSET__sQUPAuAK__"